import React from "react";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
} from "lucide-react";
import { useNavigate } from "react-router-dom"; // Added for navigation
import mnrlogo from "../../assets/mnrlogo.png";

const Footer = () => {
  const navigate = useNavigate();
  
  // Check if the staff is authenticated (using the same key as your Navbar)
  const isAuthenticated = localStorage.getItem('isStaffAuthenticated') === 'true';

  return (
    <footer className="bg-orange-950 text-white pt-16 pb-8 border-t-4 border-orange-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Section 1: Temple Logo & Name */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-16 h-18 flex items-center justify-center shadow-orange-200 shadow-lg overflow-hidden">
                <img
                  src="/icon.png"
                  alt="Temple Icon"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-xl font-serif font-bold leading-tight">
                  Sri Bramhasutra <br />
                  Marakatha Shivalingam Devasthanam
                </h3>
              </div>
            </div>
            <p className="text-orange-100/70 text-sm leading-relaxed">
              Serving devotees since the 11th Century. Experience the divine
              presence of Lord Someshwara in the heart of Chandippa.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/markathashivalingam"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-orange-100/80 hover:text-white transition-all group"
              >
                <div className="bg-white/10 p-2 rounded-lg group-hover:bg-orange-600 transition-colors">
                  <Facebook size={18} />
                </div>
                <span className="text-sm font-medium tracking-wide">
                  markathashivalingam
                </span>
              </a>
            </div>
          </div>

          {/* Section 2: Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b border-orange-800 pb-2 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm text-orange-100/80">
              <li>
                <button
                  onClick={() => navigate("/")}
                  className="hover:text-orange-400 hover:translate-x-1 transition-all inline-block"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/about-us")}
                  className="hover:text-orange-400 hover:translate-x-1 transition-all inline-block"
                >
                  Devasthanam History
                </button>
              </li>
              
              {/* Conditional Rendering: Staff Login OR Dashboard */}
              <li>
                {isAuthenticated ? (
                  <button
                    onClick={() => navigate("/dashboard")}
                   className="hover:text-orange-400 hover:translate-x-1 transition-all inline-block"
                  >
                     Dashboard
                  </button>
                ) : (
                  <button
                    onClick={() => navigate("/login")}
                    className="hover:text-orange-400 hover:translate-x-1 transition-all inline-block"
                  >
                    Staff Login
                  </button>
                )}
              </li>

              <li>
                <button
                  onClick={() => navigate("/donations")}
                  className="hover:text-orange-400 hover:translate-x-1 transition-all inline-block"
                >
                  Donations (Annadanam)
                </button>
              </li>
            </ul>
          </div>

          {/* Section 3: Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b border-orange-800 pb-2 inline-block">
              Reach Us
            </h4>
            <ul className="space-y-4 text-sm text-orange-100/80">
              <li className="flex gap-3">
                <MapPin className="text-orange-500 shrink-0" size={18} />
                <span>
                  Chandippa Village, Shankarpalli Mandal, Ranga Reddy Dist,
                  Telangana, India-501203
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-orange-500 shrink-0" size={18} />
                <span>+91 76808 79388, +91 96669 59911</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-orange-500 shrink-0" size={18} />
                <span>srimarakathashivalingam@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar with Developer Credit */}
        <div className="pt-8 border-t border-orange-900 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-xs text-orange-200/50">
            © {new Date().getFullYear()} Sri Bramhasutra Marakatha Shivalingam Devasthanam. All Rights Reserved.
          </div>
          <div className="flex items-center gap-3 text-sm">
            <span className="text-orange-200/60 italic">Developed by</span>
            <a
              href="https://mnrtechnologies.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 group cursor-pointer"
            >
              <img
                src={mnrlogo}
                alt="MNR Technologies Logo"
                className="h-6 w-auto object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all"
              />
              <span className="text-orange-400 font-bold group-hover:text-white transition-colors tracking-wide uppercase text-xs">
                MNR Technologies Global Pvt Ltd, Hyderabad
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;